import { VehicleType } from '@/services/VehicleType';

export class Group {
    constructor(idGroup?: string, groupCode?: number, description?: string, vehicleTypes?:Array<VehicleType>) {
        (idGroup) ? this.idGroup = idGroup : this.idGroup = null;
        (groupCode) ? this.groupCode = groupCode : this.groupCode = null;
        (description) ? this.description = description : this.description="";
        (vehicleTypes) ? this.vehicleTypes = vehicleTypes :this.vehicleTypes =  new Array<VehicleType>();      
    };
    public idGroup: string;
    public description: string;
    public groupCode: number;
    public vehicleTypes: Array<VehicleType>;
}